import { EmptyState, FlexColumn } from '@gorila-shared-ui/components';
import { Accordion, Panel } from 'baseui/accordion';
import { useEffect } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { activePathState, reportSelectedAssetIdsState } from '../../../storage/reports';
import PathItem from './PathItem';
import PathItemTitle from './PathItemTitle';

export function PathList() {
  const { css } = useStyles();
  const selectedAssetIds = useRecoilValue(reportSelectedAssetIdsState);
  const setActivePath = useSetRecoilState(activePathState);

  useEffect(() => {
    if (selectedAssetIds) {
      setActivePath(selectedAssetIds[0]);
    }
  }, [selectedAssetIds]);

  if (!selectedAssetIds?.length) {
    return <EmptyState title="Selecciona un activo para visualizar sus trayectos." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={`${css({ flex: 1, overflow: 'hidden' })}`}
    >
      <AutoSizer>
        {({ width, height }) => (
          <div style={{ width, height, overflow: 'auto' }}>
            <Accordion
              key={selectedAssetIds[0]}
              initialState={{ expanded: [selectedAssetIds[0]] }}
              onChange={({ expanded }) => {
                setActivePath(expanded.length ? (expanded[0] as string) : undefined);
              }}
            >
              {selectedAssetIds.map((assetId) => (
                <Panel
                  key={assetId}
                  title={<PathItemTitle assetId={assetId} />}
                  overrides={{
                    Content: {
                      style: {
                        paddingTop: 0,
                      },
                    },
                  }}
                >
                  <PathItem assetId={assetId} />
                </Panel>
              ))}
            </Accordion>
          </div>
        )}
      </AutoSizer>
    </FlexColumn>
  );
}
